export const LOCAL_TOOLS_FLAG_KEY = 'enable-local-tools'
